import React, { useEffect } from 'react';

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Grid, Modal, Stack, Typography, useMediaQuery } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CalculateIcon from '@mui/icons-material/Calculate';

import airbticsLogo from 'src/App/assets/logoMobile.jpg';
import homePageDecorTop from 'src/App/assets/homePageAsset.svg';
import circularSvgLandingPage from 'src/App/assets/circularSvgLandingPage.svg';
import landingPagebottomSvg from 'src/App/assets/landingPagebottomSvg.svg';
import { HOMEPAGE_DARK_BLUE, HOMEPAGE_PINK } from 'src/const';
import { HomePagePropTypes } from 'src/interfaces/iproptypes';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '100vh',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      // position: 'relative',
    },
    container: {
      minHeight: '100%',
      width: '100%',
      maxWidth: '1400px',
      position: 'relative',
    },
    homePageTopRightDecorStyle: {
      position: 'absolute',
      width: '30vw',
      maxWidth: 500,
      minWidth: 300,
      // top: '-18%',
      top: '-70px',
      // right: '-4%',
    },
    heroTextContainer: {
      margin: '50px 22px',
      maxWidth: '1200px',
      paddingTop: '45px',
    },
    card: {
      width: '100%',
      maxWidth: 600,
      minWidth: 300,
      height: 300,
      background: '#fff',
      borderRadius: 8,
      boxShadow: '0 4px 10px #ccc',
      overflow: 'hidden',
      cursor: 'pointer',
    },
    homePageCircleDecorStyle: {
      position: 'absolute',
      // zIndex: -1,
      bottom: '-200px',
      left: '-200px',
      opacity: '50%',
    },
  })
);

const HomePage = ({ userCountryCode }: HomePagePropTypes) => {
  console.log('User Country Code: ', userCountryCode);
  const classes = useStyles();
  const isTablet = useMediaQuery('(max-width:1024px)');
  const isMobile = useMediaQuery('(max-width:560px)');

  return (
    <>
      <div
        className={classes.root}
        style={{
          maxHeight: isTablet ? '100%' : '100vh',
          overflow: isTablet ? 'visible' : 'hidden',
        }}
      >
        <div className={classes.container}>
          <img
            src={homePageDecorTop}
            className={classes.homePageTopRightDecorStyle}
            style={{ right: isMobile ? '-35%' : '-4%' }}
          />
          <img src={circularSvgLandingPage} className={classes.homePageCircleDecorStyle} />
          <Stack className={classes.heroTextContainer}>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 900,
                color: '#1C1C1C',
              }}
            >
              Hello, <span style={{ color: '#1D262D' }}>Investor!</span>
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 500,
                color: '#717171',
                marginTop: '20px',
              }}
            >
              Great to have you onboard. What are you looking for?
            </Typography>
          </Stack>

          <Grid
            container
            direction={isTablet ? 'column' : 'row'}
            spacing={isTablet ? 2 : 4}
            alignItems="center"
            justifyContent="space-evenly"
            gap={8}
            sx={{
              margin: '10px',
              marginTop: isMobile ? '80px' : '140px',
              marginBottom: '40px',
              padding: isTablet ? '10%' : 'auto',
            }}
          >
            {userCountryCode === 'US' && (
              <CTAButton
                title={'Discover the most profitable short-term rental locations'}
                icon={<SearchIcon sx={{ fontWeight: 700, fontSize: 60 }} />}
                invert={false}
                color={HOMEPAGE_PINK}
                redirect={'/discovery'}
              />
            )}

            <CTAButton
              title={'How much can I earn in my short-term rental?'}
              icon={<CalculateIcon sx={{ fontWeight: 700, fontSize: 60 }} />}
              invert={false}
              color={HOMEPAGE_DARK_BLUE}
              redirect={'/airbnb-data'}
            />
          </Grid>

          <img
            src={landingPagebottomSvg}
            style={{
              width: 140,
              float: 'right',
              margin: '20px',
              marginTop: '30px',
              paddingBottom: '30px',
            }}
          />
        </div>
      </div>
    </>
  );
};

const CTAButton = ({
  title,
  icon,
  invert,
  color,
  redirect,
}: {
  title: string;
  icon: JSX.Element;
  invert: boolean;
  color: string;
  redirect: string;
}) => {
  return (
    <Grid
      item
      container
      justifyContent={'center'}
      alignItems={'center'}
      direction={'row'}
      spacing={4}
      sx={{
        minHeight: '160px',
        maxWidth: '450px',
        padding: 0,
        paddingRight: '20px',
        flexWrap: 'nowrap',
        background: invert ? '#fff' : color,
        color: invert ? color : '#fff',
        borderRadius: 4,
        filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        '&:hover': {
          filter: 'drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.30)) hue-rotate(-20deg)',
          transform: 'skew(-3deg)',
        },
      }}
      onClick={() => {
        window.open(redirect, '_self');
      }}
    >
      <Grid
        item
        justifyContent={'center'}
        alignItems={'center'}
        style={{ padding: 0, margin: 'auto 20px auto 20px' }}
      >
        {icon}
      </Grid>
      <Grid
        item
        justifyContent={'center'}
        alignItems={'center'}
        style={{ padding: 0, margin: 'auto 20px auto 0px' }}
      >
        <Typography variant="h6" textAlign={'center'}>
          {title}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default HomePage;
